export default {
	SERVICES: 'companies/:company_id/services/'
}
